import { useContext, useEffect, useState } from "react";
import { SelectedLanguageContext } from "../contexts/siteContentsContext";

const useSetSiteLanguage = () => {
  const { selectedLanguage } = useContext(SelectedLanguageContext);
  const [siteContentFile, setSiteContentFile] = useState("");
  const [siteContent, setSiteContent] = useState("");


  useEffect(() => {
    if (selectedLanguage?.srcLanguageFile) 
      setSiteContentFile(selectedLanguage?.srcLanguageFile)
  }, [selectedLanguage]);

  useEffect(() => {
    if (!siteContentFile) return;

    const fetchPageContent = async () => {
      try {
        const response = await fetch(siteContentFile);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response?.status}`);
          }
          const data = await response.json();
          setSiteContent(data);
      } catch (error) {
        console.error("Error fetching site content:", error);
        setSiteContent(null);
      }
    };

    fetchPageContent();    
  }, [siteContentFile]);

  return siteContent;
};

export default useSetSiteLanguage;
